/* ============================================================
   senchado-box.js — BOX定期便 ファネルLP スロットUI コントローラ
   仕様: docs/spec-box-slot-ui.md（Sprint 1: スロット枠 / セレクターモーダル /
         localStorage 保持 / おまかせ / Huckleberry 引き継ぎURL）
   依存: senchado-box-state.js（window.SenchadoBoxState）

   プロトタイプ: prototype/box-lp-mockup.html（見た目の正）
   ============================================================ */
(function () {
  'use strict';

  var S = window.SenchadoBoxState;
  if (!S) return;

  var root = document.querySelector('[data-box]');
  if (!root) return;

  var teasEl = document.querySelector('[data-box-teas]');
  if (!teasEl) return;

  var TEAS;
  try {
    TEAS = JSON.parse(teasEl.textContent);
  } catch (e) {
    return; // データ不正時はサーバーレンダリング（noscriptリンク含む）のまま
  }
  if (!Array.isArray(TEAS) || TEAS.length === 0) return;

  var BOX_URL = root.getAttribute('data-box-url') || '';
  var SLOT_COUNT = Number(root.getAttribute('data-slot-count')) || S.DEFAULT_SLOT_COUNT;
  // CTA を有効化する最小本数（決裁3: 2本可）。Huckleberry の最小選択数確定後に settings で切替。
  // 未設定なら SLOT_COUNT（＝全枠必須）にフォールバック
  var SLOT_MIN = Number(root.getAttribute('data-slot-min')) || SLOT_COUNT;
  if (SLOT_MIN < 1) SLOT_MIN = 1;
  if (SLOT_MIN > SLOT_COUNT) SLOT_MIN = SLOT_COUNT;
  var USER_STATE = root.getAttribute('data-user-state') || 'S0';
  var ORDINALS = ['1本目', '2本目', '3本目', '4本目', '5本目'];

  var byId = {};
  TEAS.forEach(function (t) { byId[t.id] = t; });
  var validIds = TEAS.map(function (t) { return t.id; });

  var storage;
  try { storage = window.localStorage; } catch (e) { storage = null; }
  var memoryStore = (function () {
    var m = {};
    return {
      getItem: function (k) { return Object.prototype.hasOwnProperty.call(m, k) ? m[k] : null; },
      setItem: function (k, v) { m[k] = String(v); },
      removeItem: function (k) { delete m[k]; }
    };
  })();
  if (!storage) storage = memoryStore; // Safari private 等: セッション内のみ保持

  // エッジケース4: 終売（マスターに無い）商品は除去し、除去が起きたことをユーザーに知らせる。
  // load（validIds なし）→ sanitize（validIds あり）の差分で除去件数を検出する
  var rawState = S.load(storage, Date.now());
  var state = S.sanitize(rawState, Date.now(), validIds);
  var removedOnLoad = rawState.slots.length - state.slots.length;

  /* ---------- elements ---------- */
  var slotsEl = root.querySelector('[data-box-slots]');
  var countEl = root.querySelector('[data-box-count]');
  var ctaEl = root.querySelector('[data-box-cta]');
  var omakaseEl = root.querySelector('[data-box-omakase]');
  var stickyEl = document.querySelector('[data-box-sticky]');
  var stickyThumbsEl = document.querySelector('[data-box-sticky-thumbs]');
  var stickyTotalEl = document.querySelector('[data-box-sticky-total]');
  var stickyCtaEl = document.querySelector('[data-box-sticky-cta]');
  var modalEl = document.querySelector('[data-box-modal]');
  var modalTitleEl = document.querySelector('[data-box-modal-title]');
  var gridEl = document.querySelector('[data-box-grid]');
  var chaRowEl = document.querySelector('[data-box-filter-cha]');
  var tasteRowEl = document.querySelector('[data-box-filter-taste]');
  if (!slotsEl || !modalEl || !gridEl) return;

  var activeSlot = 1;
  var filterCha = 'すべて';
  var filterTaste = null;
  var lastFocused = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function ordinal(i) {
    return ORDINALS[i - 1] || i + '本目';
  }

  function persist() {
    S.save(storage, state);
    broadcast();
  }

  /* 積み上げ価格（子商品合計金額パターン）: price_yen（Liquidがmoney出力から数値化）を
     合計する。無い場合は price_display の数字だけを拾う（JPYは小数なしなので安全） */
  function teaPriceYen(tea) {
    if (typeof tea.price_yen === 'number' && tea.price_yen > 0) return tea.price_yen;
    var digits = String(tea.price_display || '').replace(/[^\d]/g, '');
    return digits ? Number(digits) : 0;
  }

  /* ---------- slots ---------- */
  function slotMeta(tea) {
    var parts = [];
    if (tea.region) parts.push(tea.region);
    if (tea.cultivar) parts.push(tea.cultivar);
    return parts.join(' / ');
  }

  // 選択本数の案内文（決裁3: 最小 SLOT_MIN 本から。2本可なら「2本から」を明示）
  function countMessage(n) {
    if (n >= SLOT_MIN) {
      if (n >= SLOT_COUNT) return SLOT_COUNT + '本を選択済み';
      return n + '本を選択済み（あと' + (SLOT_COUNT - n) + '本まで追加できます）';
    }
    return 'あと' + (SLOT_MIN - n) + '本で定期便にできます（' + SLOT_MIN + '本から）';
  }

  function renderSlots() {
    var html = '';
    for (var i = 1; i <= SLOT_COUNT; i++) {
      var s = S.getSlot(state, i);
      var tea = s ? byId[s.product_id] : null;
      if (tea) {
        var soldout = !tea.available;
        html +=
          '<div class="scbox-slot" data-box-slot="' + i + '" data-state="filled"' + (soldout ? ' data-soldout' : '') + '>' +
            (tea.seasonal ? '<span class="scbox-slot__badge">季節限定</span>' : '') +
            '<button type="button" class="scbox-slot__media" data-box-slot-open="' + i + '" aria-label="' + esc(ordinal(i)) + 'を変更">' +
              (tea.image ? '<img src="' + esc(tea.image) + '" alt="' + esc(tea.title) + '" loading="lazy">' : '<span class="scbox-slot__plus" aria-hidden="true">+</span>') +
            '</button>' +
            '<div class="scbox-slot__body">' +
              '<p class="scbox-slot__ordinal">' + esc(ordinal(i)) + '</p>' +
              '<p class="scbox-slot__name" data-box-slot-name>' + esc(tea.title) + '</p>' +
              '<p class="scbox-slot__meta">' + esc(slotMeta(tea)) + '</p>' +
              (soldout ? '<p class="scbox-slot__soldout" data-box-slot-soldout>品切れ中 — 似た味わいの茶葉をお届けします</p>' : '') +
              '<div class="scbox-slot__actions">' +
                '<button type="button" class="scbox-slot__action" data-box-slot-open="' + i + '">変更する</button>' +
                '<button type="button" class="scbox-slot__action" data-box-slot-clear="' + i + '">はずす</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      } else {
        html +=
          '<div class="scbox-slot" data-box-slot="' + i + '" data-state="empty">' +
            '<button type="button" class="scbox-slot__media" data-box-slot-open="' + i + '" aria-label="' + esc(ordinal(i)) + 'を選ぶ">' +
              '<span class="scbox-slot__plus" aria-hidden="true">+</span>' +
            '</button>' +
            '<div class="scbox-slot__body">' +
              '<p class="scbox-slot__ordinal">' + esc(ordinal(i)) + '</p>' +
              '<p class="scbox-slot__empty-label">茶葉を選ぶ</p>' +
            '</div>' +
          '</div>';
      }
    }
    slotsEl.innerHTML = html;

    var n = S.filledCount(state);
    if (countEl) countEl.textContent = countMessage(n);

    // 積み上げ価格の合計（子商品合計金額パターン）
    var total = 0;
    var priced = 0;
    // 1杯あたり換算（決裁4）用の集計は「杯数が確定できる茶葉」だけを分子・分母の両方に入れる。
    // per_cup を出さない茶葉（抹茶・ティーバッグ・内容量g不明＝cups<=0）を混ぜると、
    // 価格は分子に入るのに杯数が分母に入らず過大表示になるため、cupSubtotal も別で持つ。
    // （PDP senchado-product-hero の per_cup が抹茶/TBを除外するのと同じ設計）
    var cupSubtotal = 0;
    var totalCups = 0;
    state.slots.forEach(function (s) {
      var t = byId[s.product_id];
      if (!t) return;
      var yen = teaPriceYen(t);
      if (yen > 0) { total += yen; priced++; }
      var cups = Number(t.cups);
      if (yen > 0 && cups > 0) {
        cupSubtotal += yen;
        totalCups += cups;
      }
    });

    var totalEl = root.querySelector('[data-box-total]');
    if (totalEl) {
      if (priced > 0) {
        totalEl.hidden = false;
        var label = '合計 ¥' + total.toLocaleString('ja-JP') + (totalEl.getAttribute('data-suffix') || '');
        // 決裁4: 1杯あたり換算。杯数が確定した茶葉だけで算出し、対象が全スロットのときのみ表示。
        // 抹茶等が混ざると分母が箱全体を代表しないため、その場合は「合計」だけに留める。
        if (totalCups > 0 && cupSubtotal === total) {
          var perCup = Math.round(cupSubtotal / totalCups);
          label += ' ・1杯あたり約¥' + perCup.toLocaleString('ja-JP');
        }
        totalEl.textContent = label;
      } else {
        totalEl.hidden = true;
        totalEl.textContent = '';
      }
    }
    if (stickyTotalEl) {
      stickyTotalEl.textContent = priced > 0 ? '合計 ¥' + total.toLocaleString('ja-JP') : '';
    }

    // 決裁3: 最小本数（SLOT_MIN）以上でCTA有効化。2本可なら2本で「はじめる」が押せる
    var complete = n >= SLOT_MIN;
    var url = complete && BOX_URL ? S.buildHandoffUrl(BOX_URL, state) : null;
    [ctaEl, stickyCtaEl].forEach(function (el) {
      if (!el) return;
      el.setAttribute('aria-disabled', url ? 'false' : 'true');
      el.setAttribute('href', url || '#');
    });

    if (stickyThumbsEl) {
      var thumbs = '';
      for (var j = 1; j <= SLOT_COUNT; j++) {
        var sj = S.getSlot(state, j);
        var tj = sj ? byId[sj.product_id] : null;
        thumbs += '<span class="scbox-sticky__thumb">' + (tj && tj.image ? '<img src="' + esc(tj.image) + '" alt="">' : j) + '</span>';
      }
      stickyThumbsEl.innerHTML = thumbs;
    }
  }

  /* ---------- selector modal ---------- */
  var CHA_TYPES = ['すべて'];
  TEAS.forEach(function (t) {
    if (t.type && CHA_TYPES.indexOf(t.type) < 0) CHA_TYPES.push(t.type);
  });
  var TASTES = ['和', '香', '渋', '旨', '嫋'];

  function renderPills() {
    if (!chaRowEl || !tasteRowEl) return;
    chaRowEl.querySelectorAll('.scbox-pill').forEach(function (p) { p.remove(); });
    tasteRowEl.querySelectorAll('.scbox-pill').forEach(function (p) { p.remove(); });

    CHA_TYPES.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'scbox-pill';
      b.textContent = t;
      b.setAttribute('aria-pressed', filterCha === t ? 'true' : 'false');
      b.addEventListener('click', function () {
        filterCha = t;
        renderPills();
        renderGrid();
        refocusPill(chaRowEl, t);
      });
      chaRowEl.appendChild(b);
    });

    TASTES.forEach(function (t) {
      var count = TEAS.filter(function (x) { return x.taste === t; }).length;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'scbox-pill';
      b.textContent = t;
      if (count === 0) b.setAttribute('data-zero', '');
      b.setAttribute('aria-pressed', filterTaste === t ? 'true' : 'false');
      b.addEventListener('click', function () {
        filterTaste = (filterTaste === t) ? null : t;
        renderPills();
        renderGrid();
        refocusPill(tasteRowEl, t);
      });
      tasteRowEl.appendChild(b);
    });
  }

  // renderPills の全再生成で押下ボタンが detach されるため、同ラベルのピルへフォーカスを戻す
  function refocusPill(rowEl, label) {
    var pills = rowEl.querySelectorAll('.scbox-pill');
    for (var i = 0; i < pills.length; i++) {
      if (pills[i].textContent === label) { pills[i].focus(); return; }
    }
  }

  function renderGrid() {
    var list = TEAS.filter(function (t) {
      if (filterCha !== 'すべて' && t.type !== filterCha) return false;
      if (filterTaste && t.taste !== filterTaste) return false;
      return true;
    });

    if (list.length === 0) {
      gridEl.innerHTML = '<p class="scbox-modal__empty" data-box-grid-empty>この条件の茶葉は見つかりませんでした。条件をゆるめてお試しください。</p>';
      return;
    }

    gridEl.innerHTML = list.map(function (t) {
      // 先行発売ロック（監査 M32）: 未解禁茶葉はビルダーで選択不可（品切れと同じ非活性＋専用文言）
      // 文言は Liquid（senchado-lock-copy）が理由を判定して JSON に載せてくる。
      // 会員先行とは限らず、発売前なら「8/5 発売」「2026/08/05 08:00 から選べます」になる。
      // ここで理由を判定し直さない（2026-08-04・会員先行の誤表示 Asana 1217137716058795）。
      // fallback は古い JSON を掴んだ場合の保険。
      var locked = !!t.early_locked;
      var lockBadge = t.lock_badge || '会員先行';
      var lockNote = t.lock_note || '対象会員のみ選択できます';
      var dis = !t.available;
      var card =
        '<button type="button" class="scbox-tea-card" data-box-tea data-product-id="' + Number(t.id) + '" data-variant-id="' + Number(t.variant_id) + '"' +
          (dis || locked ? ' aria-disabled="true"' : '') +
          (dis ? ' data-unavailable' : '') +
          (locked ? ' data-early-locked' : '') + '>' +
          '<span class="scbox-tea-card__media">' +
            (locked ? '<span class="scbox-tea-card__badge">' + esc(lockBadge) + '</span>' : (t.seasonal ? '<span class="scbox-tea-card__badge">季節限定</span>' : '')) +
            (t.image ? '<img src="' + esc(t.image) + '" alt="" loading="lazy">' : '') +
          '</span>' +
          '<span class="scbox-tea-card__body">' +
            '<span class="scbox-tea-card__name">' + esc(t.title) + '</span>' +
            '<span class="scbox-tea-card__meta">' + esc(slotMeta(t)) + '</span>' +
            (t.price_display ? '<span class="scbox-tea-card__price">' + esc(t.price_display) + '</span>' : '') +
            (locked ? '<span class="scbox-tea-card__soldout">' + esc(lockNote) + '</span>' : (dis ? '<span class="scbox-tea-card__soldout">品切れ中 — 再入荷までお待ちください</span>' : '')) +
          '</span>' +
        '</button>';
      // 品種解説インライン表示（Sprint 1 機能2・glossary_term 由来）。
      // カード自体が <button> のため、解説トグルは兄弟要素として置く（ネスト禁止）
      var note = '';
      if (t.cultivar && t.cultivar_note) {
        note =
          '<button type="button" class="scbox-tea-card__info" data-box-cultivar-toggle aria-expanded="false">品種「' + esc(t.cultivar) + '」について</button>' +
          '<p class="scbox-tea-card__note" data-box-cultivar-note hidden>' + esc(t.cultivar_note) + '</p>';
      }
      return '<div class="scbox-tea-cell">' + card + note + '</div>';
    }).join('');
  }

  function openModal(slotId) {
    activeSlot = slotId;
    lastFocused = document.activeElement;
    if (modalTitleEl) modalTitleEl.textContent = '茶葉を選ぶ — ' + ordinal(slotId);
    modalEl.hidden = false;
    modalEl.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    var first = modalEl.querySelector('[data-box-modal-close]');
    if (first) first.focus();
  }

  function closeModal() {
    modalEl.hidden = true;
    modalEl.removeAttribute('data-open');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  /* ---------- omakase（おまかせ・spec 機能4） ----------
     在庫がある茶葉から空きスロットを埋める。優先度: 通年茶を先に → ランダム。茶種の重複は回避。

     2026-08-03 谷本決裁: 会員ステータス（アソート購入者/セット購入者/TTJ会員）のときだけ
     閲覧履歴で重み付けしていた処理を **削除した**。画面の見た目が変わらないぶん
     「効いているか」を誰も確認できず、実機で検証されていなかったため。
     谷本さん「確認してないやつは消したい」。再開は docs/dayx-task-ssot.md C-48 で。 */
  function omakase() {
    var chosen = state.slots.map(function (s) { return s.product_id; });
    var pool = TEAS.filter(function (t) { return t.available && !t.early_locked && chosen.indexOf(t.id) < 0; });
    pool.sort(function (a, b) {
      return ((a.seasonal ? 1 : 0) - (b.seasonal ? 1 : 0)) || (Math.random() - 0.5);
    });
    for (var i = 1; i <= SLOT_COUNT; i++) {
      if (S.getSlot(state, i)) continue;
      var usedTypes = state.slots.map(function (s) { return (byId[s.product_id] || {}).type; });
      var pick = null;
      for (var p = 0; p < pool.length; p++) {
        if (usedTypes.indexOf(pool[p].type) < 0) { pick = pool[p]; break; }
      }
      if (!pick) pick = pool[0];
      if (!pick) break;
      S.fill(state, i, { product_id: pick.id, variant_id: pick.variant_id });
      pool = pool.filter(function (t) { return t.id !== pick.id; });
    }
    persist();
    renderSlots();
  }

  /* ---------- cross-tab sync（spec エッジケース6） ---------- */
  var channel = null;
  try {
    if ('BroadcastChannel' in window) channel = new BroadcastChannel('senchado_box');
  } catch (e) { channel = null; }

  function broadcast() {
    if (channel) {
      try { channel.postMessage({ type: 'box_slots_updated' }); } catch (e) { /* noop */ }
    }
  }

  function reloadFromStorage() {
    state = S.load(storage, Date.now(), validIds);
    renderSlots();
  }

  if (channel) {
    channel.addEventListener('message', function (e) {
      if (e && e.data && e.data.type === 'box_slots_updated') reloadFromStorage();
    });
  }
  window.addEventListener('storage', function (e) {
    if (e.key === S.KEY) reloadFromStorage();
  });

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-box-slot-open]');
    if (open) {
      openModal(Number(open.getAttribute('data-box-slot-open')));
      return;
    }
    var clearBtn = e.target.closest('[data-box-slot-clear]');
    if (clearBtn) {
      var clearedId = Number(clearBtn.getAttribute('data-box-slot-clear'));
      S.clear(state, clearedId);
      persist();
      renderSlots();
      // 再描画で押下ボタンが detach されるため、同スロットの「選ぶ」ボタンへフォーカス復帰
      var reopenBtn = slotsEl.querySelector('[data-box-slot-open="' + clearedId + '"]');
      if (reopenBtn) reopenBtn.focus();
      return;
    }
    var cultivarToggle = e.target.closest('[data-box-cultivar-toggle]');
    if (cultivarToggle) {
      var noteEl = cultivarToggle.nextElementSibling;
      if (noteEl && noteEl.hasAttribute('data-box-cultivar-note')) {
        var expanded = cultivarToggle.getAttribute('aria-expanded') === 'true';
        cultivarToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        noteEl.hidden = expanded;
      }
      return;
    }
    var card = e.target.closest('[data-box-tea]');
    if (card) {
      if (card.hasAttribute('data-unavailable')) return;
      if (card.hasAttribute('data-early-locked')) return; // 監査 M32: 先行発売ロック茶葉は選択不可
      var tea = byId[Number(card.getAttribute('data-product-id'))];
      if (tea) {
        S.fill(state, activeSlot, { product_id: tea.id, variant_id: tea.variant_id });
        persist();
        closeModal();
        renderSlots();
        // renderSlots の innerHTML 再描画で旧ボタンが detach されるため、
        // 再描画後の該当スロットへフォーカスを復帰させる（a11y）
        var slotBtn = slotsEl.querySelector('[data-box-slot-open="' + activeSlot + '"]');
        if (slotBtn) slotBtn.focus();
      }
      return;
    }
    if (e.target.closest('[data-box-modal-close]') || e.target.closest('[data-box-modal-backdrop]')) {
      closeModal();
      return;
    }
    var cta = e.target.closest('[data-box-cta], [data-box-sticky-cta]');
    if (cta && cta.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (modalEl.hidden) return;
    if (e.key === 'Escape') {
      closeModal();
      return;
    }
    // フォーカストラップ: aria-modal はキーボードを拘束しないため Tab をループさせる
    if (e.key === 'Tab') {
      var focusables = modalEl.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      var list = [];
      for (var i = 0; i < focusables.length; i++) {
        if (focusables[i].offsetParent !== null) list.push(focusables[i]);
      }
      if (list.length === 0) return;
      var first = list[0];
      var last = list[list.length - 1];
      var active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || !modalEl.contains(active)) {
          e.preventDefault();
          last.focus();
        }
      } else if (active === last || !modalEl.contains(active)) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  if (omakaseEl) omakaseEl.addEventListener('click', omakase);

  /* ---------- sticky bar ---------- */
  if (stickyEl && 'IntersectionObserver' in window) {
    var builderEl = root.querySelector('[data-box-builder]') || root;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) stickyEl.removeAttribute('data-visible');
        else if (entry.boundingClientRect.top < 0) stickyEl.setAttribute('data-visible', '');
      });
    }, { threshold: 0 }).observe(builderEl);
  }

  /* ---------- init ---------- */
  // メール流入プリフィル: /pages/box?slots=<id>,<id>,... でスロット充填済みの状態で開く
  // （リピート検出→メールのパーソナライズドURL前提。メール文脈の意図を最新とみなし
  //   既存ドラフトより優先する。IDは数値バリデート済み + 茶葉マスターに実在するもののみ）
  //
  // 決裁C（トップN + 不足は空）: マスターに無い＝終売はドロップし、埋まった分だけ充填。
  //   足りない枠は空のまま本人に選ばせる（never-bought を自動補完しない）。
  // 品切れ（available=false）は "ドロップせず" スロットに残す。フォールバック方針
  //   （全茶葉登録＋ロジレス差替え）と整合し、renderSlots が「品切れ中 — 似た味わいの
  //   茶葉をお届けします」バッジ＋グレーアウトで表示する。「いつもの」の認識を保つため。
  var prefillIds = S.parseIdListParam(window.location.search, 'slots')
    // 監査 M32: ?slots= で先行発売ロック茶葉を流し込む迂回を防ぐ（グリッド選択と同じガード）
    .filter(function (id) { return byId[id] && !byId[id].early_locked; })
    .slice(0, SLOT_COUNT);
  if (prefillIds.length > 0) {
    S.clearAll(state);
    prefillIds.forEach(function (id, idx) {
      S.fill(state, idx + 1, { product_id: id, variant_id: byId[id].variant_id });
    });
    persist();
    // ビルダーを上部にせり上げる（CSS order・プリフィル時のみ）
    root.setAttribute('data-box-prefilled', '');
    // プリフィルバナー: 商品名（先頭の充填茶葉）を差し込む
    var bannerEl = root.querySelector('[data-box-prefill-banner]');
    if (bannerEl) {
      var firstTea = byId[prefillIds[0]];
      var tmpl = bannerEl.getAttribute('data-template') || 'いつもの「{name}」をスロットに入れてあります。このまま定期便にできます。中身の入れ替えも自由です。';
      bannerEl.textContent = firstTea ? tmpl.replace('{name}', firstTea.title) : bannerEl.getAttribute('data-fallback') || 'いつもの茶葉をスロットに入れてあります。このまま定期便にできます。';
      bannerEl.hidden = false;
    }
  }

  root.setAttribute('data-box-ready', '');
  if (removedOnLoad > 0 && prefillIds.length === 0) {
    var removedNoteEl = root.querySelector('[data-box-removed-note]');
    if (removedNoteEl) removedNoteEl.hidden = false;
  }
  renderPills();
  renderGrid();
  renderSlots();
})();
